import { useIntl } from 'react-intl';
import Alert from 'client/components/ui/Alert/Alert';
import Modal from 'client/components/ui/Modal/Modal';
import Button from 'client/components/aria/Button/Button';
import { removeMapMode } from 'client/store/mapSlice/mapSlice';
import { useDispatch } from 'react-redux';
import { mapModes } from 'client/utils/constants/appStates';
import styles from './MobileDrawModal.module.scss';
const { DRAWING } = mapModes;

export const MobileDrawModal = ({ showCreateMobileAOIDialog, setCreateMobileAOIDialog, setDrawMobileArea }) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const handleCancel = () => {
        setDrawMobileArea(false);
        setCreateMobileAOIDialog(false);
        dispatch(removeMapMode(DRAWING));
    };

    const handleSave = () => {
        setDrawMobileArea(true);
        setCreateMobileAOIDialog(false);
    };

    const saveDialogActions = <div className={styles.actions}>
        <Button
            data-testid="mobile.cancel.aoi.button"
            variant="error"
            onPress={handleCancel}
        >
            {intl.formatMessage({ id: 'no' })}
        </Button>
        <Button
            data-testid="mobile.confirm.aoi.button"
            variant="success"
            onPress={handleSave}
        >
            {intl.formatMessage({ id: 'yes' })}
        </Button>
    </div>;

    return <Modal
        data-testid="create.aoi.dialog"
        open={showCreateMobileAOIDialog}
    >
        <Alert data-testid="create.aoi.dialog.alert">
            <h1 className="govuk-label-wrapper">
                <label className="govuk-label govuk-label--l" htmlFor="create.aoi.dialog.alert">
                    {intl.formatMessage({ id: 'mapToolbar.mobile.create.aoi.dialog.title' })}
                </label>
            </h1>
            <div className={['govuk-form-group', styles.form].join(' ')}>
                <div className="govuk-hint">
                    {intl.formatMessage({ id: 'mapToolbar.mobile.create.aoi.dialog.message' })}
                </div>
                {saveDialogActions}
            </div>
        </Alert>
    </Modal>;
};
